import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { useState, useRef, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import ReactFocusLock from 'react-focus-lock';
import styles from './9004ae3e283a804c8a9986bc70750aad5505cf272dd724b47408df40859fc340.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../IconButton/fa92464f43077b1cbdd0bb416ee549d83eadaee9906eab0987bbf0ad889eddad.cfe-internal.js';
import CloseIcon from '../../icons/components/d75b7d62e2d618a2ae2b81c1622c1e68663cf5c48535c80292d4154d2269378b.cfe-internal.js';
import useModalContext, { ModalContextProvider } from './78140e32fb98e2313134bd708af4bca122163c4f00d7d89bc3ab50898eccb2a0.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/f8ce5c85f293b5c4ca8be6bc5ac9f246003ac61cc91ab03b8814ccaab638a21a.cfe-internal.js';
import Portal from '../../utils/Portal/021a1fdc9ca1735be9937767b2058e59614ca8e92028492bbc50e54e37b552ec.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import IconButton from '../IconButton/399631eebecc03da030561fb1a25c35c2d29c5e4645700b7fca3cf592ca75904.cfe-internal.js';

var _excluded = ["children"],
  _excluded2 = ["open", "onDismiss", "zIndex", "children", "style", "disabledFocusLock"],
  _excluded3 = ["unstable_maxSize", "open", "children", "onClick", "className"],
  _excluded4 = ["unstable_maxSize", "open", "elementRefToFocusOnOpen", "unstable_isHeightExpandedToMaxSize", "onDismiss", "onClose", "elementRefToFocusOnClose", "children", "zIndex", "portalTarget", "dangerouslyDisableFocusLock"],
  _excluded5 = ["children", "className"],
  _excluded6 = ["children", "className"],
  _excluded7 = ["children", "className"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var OverlayContainer = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref
  }), children, /*#__PURE__*/React__default.createElement("style", null, "body { overflow: hidden; }"));
});
var Overlay = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var _ref2$open = _ref2.open,
    open = _ref2$open === void 0 ? false : _ref2$open,
    onDismiss = _ref2.onDismiss,
    zIndex = _ref2.zIndex,
    children = _ref2.children,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    _ref2$disabledFocusLo = _ref2.disabledFocusLock,
    disabledFocusLock = _ref2$disabledFocusLo === void 0 ? false : _ref2$disabledFocusLo,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var classes = classNames(styles.backdrop, _defineProperty(_defineProperty({}, styles.fadeEnter, open), styles.fadeLeave, !open));
  var overlay = React__default.useRef(null);
  var _useModalContext = useModalContext(),
    onClose = _useModalContext.onClose;
  var mouseDownTarget = React__default.useRef();
  var handleMouseDown = function handleMouseDown(e) {
    mouseDownTarget.current = e.target;
  };
  var handleClick = function handleClick(e) {
    // Ensure that when a user clicks on the dialog and drags and lifts out on the overlay,
    // the modal does not fire onDismiss.
    if (e.target === mouseDownTarget.current && e.target === overlay.current) {
      onDismiss === null || onDismiss === void 0 || onDismiss(e);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Escape') {
      e.stopPropagation(); // prevent event from closing modals or popovers
      onDismiss === null || onDismiss === void 0 || onDismiss(e);
      onClose === null || onClose === void 0 || onClose(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(ReactFocusLock, {
    disabled: disabledFocusLock,
    autoFocus: false,
    as: OverlayContainer,
    className: classes,
    ref: mergeRefs(ref, overlay),
    lockProps: _objectSpread(_objectSpread({}, rest), {}, {
      style: _objectSpread({
        zIndex: zIndex
      }, style),
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      onKeyDown: handleKeyDown
    })
  }, children);
});
var Dialog = /*#__PURE__*/React__default.forwardRef(function (_ref3, ref) {
  var unstable_maxSize = _ref3.unstable_maxSize,
    _ref3$open = _ref3.open,
    open = _ref3$open === void 0 ? false : _ref3$open,
    children = _ref3.children,
    onClick = _ref3.onClick,
    className = _ref3.className,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var getMaxSizeStyles = function getMaxSizeStyles() {
    if (unstable_maxSize) {
      var prefix = 'dialog';
      switch (unstable_maxSize) {
        case 'small':
          return "".concat(prefix, "Small");
        case 'medium':
          return "".concat(prefix, "Medium");
        case 'large':
          return "".concat(prefix, "Large");
        case 'xl':
          return "".concat(prefix, "ExtraLarge");
        default:
          return '';
      }
    }
    return '';
  };
  var _useModalContext2 = useModalContext(),
    isHeightExpandedToMaxSize = _useModalContext2.isHeightExpandedToMaxSize;
  var classes = classNames(styles.modal, styles[getMaxSizeStyles()], className, _defineProperty(_defineProperty(_defineProperty({}, styles.growToMaxHeight, isHeightExpandedToMaxSize), styles.zoomEnter, open), styles.zoomLeave, !open));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events
    React__default.createElement("div", _extends({}, rest, {
      "aria-modal": "true",
      role: "dialog",
      tabIndex: -1,
      ref: ref,
      className: classes,
      onClick: onClick
    }), children)
  );
});
var Modal = /*#__PURE__*/React__default.forwardRef(function (_ref4, ref) {
  var unstable_maxSize = _ref4.unstable_maxSize,
    _ref4$open = _ref4.open,
    open = _ref4$open === void 0 ? false : _ref4$open,
    elementRefToFocusOnOpen = _ref4.elementRefToFocusOnOpen,
    _ref4$unstable_isHeig = _ref4.unstable_isHeightExpandedToMaxSize,
    isHeightExpandedToMaxSize = _ref4$unstable_isHeig === void 0 ? false : _ref4$unstable_isHeig,
    onDismiss = _ref4.onDismiss,
    onClose = _ref4.onClose,
    elementRefToFocusOnClose = _ref4.elementRefToFocusOnClose,
    children = _ref4.children,
    _ref4$zIndex = _ref4.zIndex,
    zIndex = _ref4$zIndex === void 0 ? 1000 : _ref4$zIndex,
    portalTarget = _ref4.portalTarget,
    _ref4$dangerouslyDisa = _ref4.dangerouslyDisableFocusLock,
    dangerouslyDisableFocusLock = _ref4$dangerouslyDisa === void 0 ? false : _ref4$dangerouslyDisa,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isInDOM = _React$useState2[0],
    setIsInDOM = _React$useState2[1];
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    elementUsedToOpenModal = _useState2[0],
    setElementUsedToOpenModal = _useState2[1];
  var dialogRef = useRef(null);
  var closeIconButtonRef = useRef(null);
  useEffect(function () {
    if (open) {
      setIsInDOM(true);
      setElementUsedToOpenModal(document.activeElement);
    }
  }, [open]);

  // This effect should only run when the Modal is added or removed from the DOM
  useDidUpdate(function () {
    if (isInDOM) {
      if (elementRefToFocusOnOpen !== null && elementRefToFocusOnOpen !== void 0 && elementRefToFocusOnOpen.current) {
        elementRefToFocusOnOpen.current.focus();
      } else if (typeof onClose === 'function' && closeIconButtonRef.current) {
        closeIconButtonRef.current.focus();
      } else {
        var _dialogRef$current;
        (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 || _dialogRef$current.focus();
      }
    } else if (elementRefToFocusOnClose !== null && elementRefToFocusOnClose !== void 0 && elementRefToFocusOnClose.current) {
      elementRefToFocusOnClose.current.focus();
    } else {
      /*
       * This replaces the `returnFocus` prop of `react-focus-lock`.
       * The logic is done in this effect instead because `elementRefToFocusOnClose.current` is not available until after the `Overlay` is unmounted.
       */
      elementUsedToOpenModal === null || elementUsedToOpenModal === void 0 || elementUsedToOpenModal.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInDOM]);
  var context = useMemo(function () {
    return {
      onClose: onClose,
      closeIconButtonRef: closeIconButtonRef,
      isHeightExpandedToMaxSize: isHeightExpandedToMaxSize
    };
  }, [onClose, closeIconButtonRef, isHeightExpandedToMaxSize]);
  return /*#__PURE__*/React__default.createElement(Portal, {
    portalTarget: portalTarget
  }, isInDOM ? /*#__PURE__*/React__default.createElement(ModalContextProvider, {
    value: context
  }, /*#__PURE__*/React__default.createElement(Overlay, {
    open: open,
    disabledFocusLock: dangerouslyDisableFocusLock,
    zIndex: zIndex,
    onAnimationEnd: function onAnimationEnd() {
      return !open && setIsInDOM(false);
    },
    onDismiss: onDismiss
  }, /*#__PURE__*/React__default.createElement(Dialog, _extends({}, rest, {
    unstable_maxSize: unstable_maxSize,
    ref: mergeRefs(dialogRef, ref),
    open: open
  }), children))) : null);
});
var ModalHeader = /*#__PURE__*/React__default.forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
    className = _ref5.className,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  var _useModalContext3 = useModalContext(),
    onClose = _useModalContext3.onClose,
    closeIconButtonRef = _useModalContext3.closeIconButtonRef;
  var classes = classNames(styles.modalHeader, className, _defineProperty({}, styles.modalHeaderWithCloseButton, onClose));
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classes
  }), children, typeof onClose === 'function' ? /*#__PURE__*/React__default.createElement(IconButton, {
    className: styles.modalHeaderCloseButton,
    onClick: onClose,
    "aria-label": translate('close'),
    ref: closeIconButtonRef
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)) : null);
});
var ModalBody = /*#__PURE__*/React__default.forwardRef(function (_ref6, ref) {
  var children = _ref6.children,
    className = _ref6.className,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  var classes = classNames(styles.modalBody, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classes
  }), children);
});
var ModalFooter = /*#__PURE__*/React__default.forwardRef(function (_ref7, ref) {
  var children = _ref7.children,
    className = _ref7.className,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  var classes = classNames(styles.modalFooter, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classes
  }), children);
});

export { Modal, ModalBody, ModalFooter, ModalHeader };
